import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import WdSvgIcon from '@main/core/WdSvgIcon';

export const NotificationPanelToggleButton = ({ children, isEmpty = true, onClick }) => {
  return (
    <IconButton className="w-40 h-40" onClick={onClick} size="large">
      <Badge color="secondary" invisible={isEmpty} badgeContent={children}>
        <WdSvgIcon>heroicons-outline:bell</WdSvgIcon>
      </Badge>
    </IconButton>
  );
};
